import { useState, useEffect } from "react";
import BecomeASeller from "./components/become-a-seller/BecomeASeller";
import Header from "./components/header/Header";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Footer from "./components/footer/Footer";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import ForgotPassword from "./pages/ForgotPassword";
import Error from "./pages/Error";
import Protected from "./components/protected-route/Protected";
import Communities from "./pages/Communities";
import Explore from "./pages/Explore";
import SellNow from "./pages/SellNow";
import Seller from "./pages/Seller";
import { useDispatch } from "react-redux";
import { getSellers } from "./slice/sellers/sellersSlice";
import { getUserCart } from "./slice/cart/cartSlice";
import { getUserFavourite } from "./slice/favourite/favouriteSlice";
import { getExploreData } from "./slice/explore/exploreSlice";
import SellerOverview from "./pages/seller-hub/SellerOverview";
import SellerInventory from "./pages/seller-hub/SellerInventory";
import SellerSales from "./pages/seller-hub/SellerSales";
import SellerWallet from "./pages/seller-hub/SellerWallet";
import SellerProfile from "./pages/seller-hub/SellerProfile";
import { Toaster } from "react-hot-toast";
import useAuth from "./hooks/useAuth";
import Checkout from "./pages/Checkout";
import Cart from "./pages/Cart";
import Profile from "./pages/Profile";
import Base from "./layouts/Base";
import { getUserProfileImage } from "./slice/profile/profileSlice";
import Main from "./layouts/Main";
import Backdrop from "./components/seller-hub/backdrop/Backdrop";
import { useLocation } from "react-router-dom";

function App() {
  const { user } = useAuth();

  const dispatch = useDispatch();

  const location = useLocation();
  const visibleRoutes = ["/communities", "/explore"];

  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const toggleSidebar = () => {
    setOpenMobileMenu((prev) => !prev);
  };

  useEffect(() => {
    dispatch(getExploreData());
  }, [dispatch]);

  useEffect(() => {
    if (user?.data) {
      dispatch(getUserProfileImage());
      dispatch(getSellers());
      dispatch(getUserCart());
      dispatch(getUserFavourite());
    }
  }, [dispatch, user?.data]);

  return (
    <>
      <Base openMobileMenu={openMobileMenu}>
        <Header
          toggler={toggleSidebar}
          open={openMobileMenu}
          close={setOpenMobileMenu}
        />
        <Main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="*" element={<Error />} />
            <Route
              path="/unauthorized"
              element={
                <p className="text-center">
                  You can't access the seller's hub because you have not created
                  a seller account yet.
                </p>
              }
            />
            <Route path="/explore" element={<Explore />} />

            <Route element={<Protected userRole={"USER"} />}>
              <Route path="/communities" element={<Communities />} />
              <Route path="/sell-now" element={<SellNow />} />
              <Route path="/cart/checkout" element={<Checkout />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/seller-details" element={<Seller />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            <Route element={<Protected userRole={"SELLER"} />}>
              <Route path="/seller-overview" element={<SellerOverview />} />
              <Route path="/seller-inventory" element={<SellerInventory />} />
              <Route path="/seller-sales" element={<SellerSales />} />
              <Route path="/seller-wallet" element={<SellerWallet />} />
              <Route path="/seller-profile" element={<SellerProfile />} />
            </Route>
          </Routes>
          <div
            className={`${
              visibleRoutes.includes(location.pathname) ? "block" : "hidden"
            }`}
          >
            <BecomeASeller
              data={
                user?.data?.roles.find((role) => role?.code.includes("SELLER"))
                  ? {
                      text: "Switch to your seller account?",
                      btnText: "Switch",
                      href: "/seller-overview",
                    }
                  : {
                      text: "Want to become a seller?",
                      btnText: "Sell Now",
                      href: "/sell-now",
                    }
              }
            />
          </div>
        </Main>
        <Footer />
        <Backdrop />
      </Base>
      <div className="">
        <Toaster
          toastOptions={{
            success: {
              style: {
                background: "green",
                color: "white",
              },
            },
            error: {
              style: {
                background: "#A91E24",
                color: "white",
              },
            },
          }}
        />
      </div>
    </>
  );
}

export default App;
